import { fetchData, postData, updateData } from "../utils/apiUtils";
import useGetUserToken from "../utils/getUserToken";
function useUserApi() {
  const token = useGetUserToken();
  const all_user = async () => {
    const url = `employee/user/getall`;
    const responseData = await fetchData(url, token);
    return responseData;
  };
  const AddNewUser = async (newUser) => {
    const url = `employee/user/register`;
    const responseData = await postData(url, newUser, token);
    return responseData;
  };

  const ChangeUsrPassword = async (newPassword) => {
    const url = `employee/user/changepassword`;
    const responseData = await postData(url, newPassword, token);
    return responseData;
  };

  const ResetUsrPassword = async (newPassword) => {
    const url = `employee/user/resetpassword`;
    const responseData = await postData(url, newPassword, token);
    return responseData;
  };

  const getPermissionList = async () => {
    const url = `employee/permession`;
    const responseData = await fetchData(url, token);
    return responseData;
  };

  const RegisterNewPermission = async (newPassword) => {
    const url = `employee/permession/register`;
    const responseData = await postData(url, newPassword, token);
    return responseData;
  };

  return {
    ChangeUsrPassword,
    all_user,
    AddNewUser,
    ResetUsrPassword,
    getPermissionList,
    RegisterNewPermission,
  };
}

export default useUserApi;
